import React from 'react';
import HeroSection from '../components/Banner';
import EventPage from '../components/Events';

function HomeScreen() {
  return (
    <div>
      <HeroSection />
      <EventPage />
    </div>
  );
}

export default HomeScreen;
